export class LocalStorage {

    constructor() {
        this.localHistory = JSON.parse(localStorage.getItem('search_history')) || []
    }

    load() {
      return (this.localHistory.length > 3) ? this.localHistory.slice((this.localHistory.length - 3), this.localHistory.length) : this.localHistory;
    }

    save(term) {
        if (term && this.localHistory.indexOf(term) === -1) {
          if (this.localHistory.length && this.localHistory.length >= 3) {
            this.remove(0)
          }
          this.localHistory.push(term)
          localStorage.setItem('search_history', JSON.stringify(this.localHistory))
        }
    }

    remove(index) {
        if(index != undefined)
            this.localHistory.splice(index, 1)

        localStorage.setItem('search_history', JSON.stringify(this.localHistory))
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/localstorage.js